import { appendIf, capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { exportsClient } from '../../../../utils/apollo/api'
import { useExports } from '../_load/ExportsLoader'
import { useModalData } from '../../../../components/modals/ModalsContext'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import ListCounter from '../../../../components/helpers/ListCounter'
import Loading from '../../../../components/helpers/Loading'
import Tag from '../../../../packages/kiti/components/presentation/Tag'

const ExportHistoryTable = () => {
  const { t } = useTranslation(['export', 'common'])
  const entity = useModalData()
  const data = useExports()

  const columns = [
    {
      label: t('date'),
      dataIndex: 'insertedAt',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm'),
      headerSideContent: (
        <>
          <ListCounter
            client={exportsClient}
            entity="exports"
            filterName="ExportFilter"
            size="xsmall"
            bold
            filters={{ entities: entity }}
          />
          <RefetchingIndicator />
        </>
      )
    },

    ...appendIf(!entity, {
      label: t('entity'),
      dataIndex: ['entity'],
      flex: 2,
      format: entity => t('common:entity.' + entity, '')
    }),

    {
      label: t('user'),
      dataIndex: ['createdBy', 'name'],
      flex: 2,
      format: capitalizeAllIfLower
    },

    {
      label: t('download'),
      sortIndex: false,
      flex: 1,
      render: (_, record) => {
        const hasError = record.status === 'error'
        const src = record.oldDocument?.Location || record.document?.src
        if (hasError) return <Tag label={t('error')} color="red" transparent />
        if (!src) return <Loading />
        return (
          <a href={src} target="_blank" rel="noopener noreferrer" download>
            <Icon name="RiDownloadCloud2Line" size="1rem" />
          </a>
        )
      }
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default ExportHistoryTable
